var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMergedBlue = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 18",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".merged-icon-all-blue{fill:#284B9E;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1"
}, /*#__PURE__*/React.createElement("path", {
  className: "merged-icon-all-blue",
  d: "M3.24,8h.79v3.4s-.13,1.73,1.55,1.73v-.94l1.16,1.4-1.16,1.4v-.94s-2.29.26-2.29-2.61l-.05-3.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "merged-icon-all-blue",
  d: "M18.74,8h-.79s0,3.4,0,3.4c0,0,.13,1.73-1.55,1.73v-.94s-1.16,1.4-1.16,1.4l1.16,1.4v-.94s2.29.26,2.29-2.61l.05-3.45Z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2"
}, /*#__PURE__*/React.createElement("path", {
  className: "merged-icon-all-blue",
  d: "M9.05,16.44h2.72v-.78h-2.72v.78ZM9.05,14.89h3.89v-.78h-3.89v.78ZM9.05,13.33h3.89v-.78h-3.89v.78ZM8.27,18c-.21,0-.4-.08-.55-.23-.15-.15-.23-.34-.23-.55v-5.44c0-.21.08-.4.23-.55.15-.15.34-.23.55-.23h5.44c.21,0,.4.08.55.23s.23.34.23.55v5.44c0,.21-.08.4-.23.55-.15.15-.34.23-.55.23h-5.44ZM8.27,17.22h5.44v-5.44h-5.44v5.44ZM8.27,11.78v5.44-5.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "merged-icon-all-blue",
  d: "M4.05,5.44h2.72v-.78h-2.72v.78ZM4.05,3.89h3.89v-.78h-3.89v.78ZM4.05,2.33h3.89v-.78h-3.89v.78ZM3.27,7c-.21,0-.4-.08-.55-.23-.15-.15-.23-.34-.23-.55V.78c0-.21.08-.4.23-.55.15-.15.34-.23.55-.23h5.44c.21,0,.4.08.55.23s.23.34.23.55v5.44c0,.21-.08.4-.23.55-.15.15-.34.23-.55.23H3.27ZM3.27,6.22h5.44V.78H3.27v5.44ZM3.27.78v5.44V.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "merged-icon-all-blue",
  d: "M14.05,5.44h2.72v-.78h-2.72v.78ZM14.05,3.89h3.89v-.78h-3.89v.78ZM14.05,2.33h3.89v-.78h-3.89v.78ZM13.27,7c-.21,0-.4-.08-.55-.23-.15-.15-.23-.34-.23-.55V.78c0-.21.08-.4.23-.55.15-.15.34-.23.55-.23h5.44c.21,0,.4.08.55.23s.23.34.23.55v5.44c0,.21-.08.4-.23.55-.15.15-.34.23-.55.23h-5.44ZM13.27,6.22h5.44V.78h-5.44v5.44ZM13.27.78v5.44V.78Z"
}))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMergedBlue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/merged_blue.e1b4d567.svg";
export { ForwardRef as ReactComponent };